import { objectToQueryString } from '@/utils/url';
/**
 * 중앙 정렬 팝업 열기
 * @param url
 * @param title
 * @param width
 * @param height
 * @returns
 */
export const popupConfigCenter = (url, popupId, width = 1024, height = 768) => {
    // 화면 크기를 기준으로 중앙 팝업 창 위치 계산
    const screenLeft = window.screenLeft ?? window.screenX;
    const screenTop = window.screenTop ?? window.screenY;
    const screenWidth = window.innerWidth ?? document.documentElement.clientWidth;
    const screenHeight = window.innerHeight ?? document.documentElement.clientHeight;
    const left = screenLeft + (screenWidth - width) / 2;
    const top = screenTop + (screenHeight - height) / 2;
    // 팝업 옵션 설정
    // const popupOptions = `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`;
    const popupOptions = {
        width,
        height,
        top,
        left,
        resizable: true,
        scrollbars: true,
    };
    const option = objectToQueryString(popupOptions);
    // 팝업 열기
    const popupWindow = window.open(url, popupId, option);
    if (!popupWindow) {
        console.log('Popup blocked. Please enable popups in your browser settings.');
        return null;
    }
    return popupWindow;
};
/**
 * 우측 하단 팝업 열기
 * @param url
 * @param title
 * @param width
 * @param height
 * @returns
 */
export const popupConfigRightBottom = (url, popupId, width = 1024, height = 768) => {
    // 화면 크기를 기준으로 우측 하단 팝업 창 위치 계산
    const screenLeft = window.screenLeft ?? window.screenX;
    const screenTop = window.screenTop ?? window.screenY;
    const screenWidth = window.innerWidth ?? document.documentElement.clientWidth;
    const screenHeight = window.innerHeight ?? document.documentElement.clientHeight;
    const left = screenLeft + (screenWidth - width);
    const top = screenTop + (screenHeight - height);
    // 팝업 옵션 설정
    // const popupOptions = `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`;
    const popupOptions = {
        width,
        height,
        top,
        left,
        resizable: true,
        scrollbars: true,
    };
    const option = objectToQueryString(popupOptions);
    // 팝업 열기
    const popupWindow = window.open(url, popupId, option);
    if (!popupWindow) {
        console.log('Popup blocked. Please enable popups in your browser settings.');
        return null;
    }
    return popupWindow;
};
/**
 * 팝업 열기
 */
export const openPopup = (url, popupData) => {
    if (popupData.position === 'center') {
        return popupConfigCenter(url, popupData.id, popupData.width, popupData.height);
    }
    if (popupData.position === 'right-bottom') {
        return popupConfigRightBottom(url, popupData.id, popupData.width, popupData.height);
    }
    return null;
};
